<template>
  <table class="jps-table ui-sortable-search-result-table">
    <tbody>
      <template v-for="c in category.values">
        <tr v-if="categoryCount[c.code]">
          <th>{{ ls(c.value) }}</th>
          <td>
            <a :href="categoryLink(c.code)">
              {{ num(categoryCount[c.code]) }}
            </a>
          </td>
        </tr>
      </template>
    </tbody>
  </table>
</template>

<script lang="ts" setup>
const { isJps } = useServiceType()
const { ls, lss, num, led } = useI18n()
const { $getCodeDbCategory } = useNuxtApp()

interface Props {
  categoryCount: { [key: string]: number }
}
const props = withDefaults(defineProps<Props>(), {})

const category = $getCodeDbCategory()

const categoryLink = (keys: string) => {
  return `/csearch/${systemCrossSearchId()}?csid=${systemCrossSearchId()}&from=0&f-cm=` + keys
}
</script>
